"use client";

import { Children, isValidElement, type ReactNode } from "react";
import { toast } from "sonner";

export interface CopyToClipboardProps {
  value?: { useSelf?: boolean; value?: string } | string;
  useSelf?: boolean;
  children: ReactNode;
}

function textContent(node: ReactNode): string {
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (!node) return "";
  if (Array.isArray(node)) return node.map(textContent).join("");
  if (isValidElement<{ children?: ReactNode }>(node)) {
    return textContent(node.props.children);
  }
  return Children.toArray(node).map(textContent).join("");
}

export default function CopyToClipboard({
  value,
  useSelf,
  children,
}: CopyToClipboardProps) {
  const options =
    typeof value === "object" && value !== null
      ? value
      : { value, useSelf };

  function copyText() {
    navigator.clipboard.writeText(
      options.useSelf ? textContent(children) : (options.value ?? ""),
    );
    toast.success("Copied to clipboard");
  }

  return (
    <span className="cursor-pointer" onClick={copyText}>
      {children}
    </span>
  );
}
